import "./contacts.scss";
import TelegramIcon from "../socials/TelegramIcon";
import {LinkMail, LinkPhone} from "../links";

export default function Contacts() {
  return (
    <div className={'contacts'}>
      <p className={'in-one-line'}>630090, г. Новосибирск, ул. Пирогова 4</p>
      <p>
        <span>Телефон: </span>
        <LinkPhone to={'+73833634163'}>(383) 363-41-63</LinkPhone>
      </p>
      <p>
        <span>E-mail: </span>
        <LinkMail to={'vsesib@nsu.ru'}>vsesib@nsu.ru</LinkMail>
      </p>
      <p>
        <span>Наши соц. сети: </span>
        <TelegramIcon/>
      </p>
    </div>
  );
}
